import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { alertActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  getMarketerPipelinesApi,
  createMarketerPipelineApi,
  updateMarketerPipelineApi,
  deleteMarketerPipelinesApi,
} from "services/marketerPipeline/marketerPipeline.thunks";
import PipelineCreate from "../../components/PipelineCreate";
import PipelineTable from "../../components/PipelineTable";
import { ERR_MSG } from "constants/labels";

const ManageMarketerPipeline = () => {
  const header = "Manage Marketer Pipelines";
  const dispatch = useDispatch();
  const [rawTableData, setRawTableData] = useState([]);

  const fetchPipelines = async () => {
    try {
      const res = await dispatch(getMarketerPipelinesApi()).unwrap();
      if (!res || !res?.Succeeded) {
        dispatch(
          alertActions.error({
            message: res?.Message || ERR_MSG["073"],
            header,
          }),
        );
        return;
      }
      setRawTableData(res?.Data || []);
    } catch (error) {
      dispatch(
        alertActions.error({
          message: error.message ? ERR_MSG["073"] : error,
          header,
        }),
      );
    }
  };

  useEffect(() => {
    fetchPipelines();
  }, []);

  return (
    <>
      <Typography component="div" className="userprofilelist">
        <Grid container direction="row" spacing={2}>
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>
            <Typography variant="h2" className="userprofilelistcontent">
              {header}
            </Typography>
          </Grid>
        </Grid>
      </Typography>
      <Grid container justifyContent={"flex-end"} alignItems={"center"}>
        {rawTableData && (
          <PipelineCreate
            pipelines={rawTableData}
            handleRefresh={fetchPipelines}
            createApi={createMarketerPipelineApi}
            header={header}
            title="Create Pipeline"
            buttonLabel="Pipeline"
          />
        )}
      </Grid>
      <Typography component="div">
        {rawTableData && (
          <PipelineTable
            rawTableData={rawTableData}
            handleRefresh={fetchPipelines}
            updateApi={updateMarketerPipelineApi}
            deleteApi={deleteMarketerPipelinesApi}
            header={header}
            emptyMessage="No marketer pipeline data found."
          />
        )}
      </Typography>
    </>
  );
};

export default ManageMarketerPipeline;
